'use es6';

import getLang from 'I18n/utils/getLang';
import { ALL_COLLECTIONS_COLLECTION_FETCH_RECEIVED, ALL_COLLECTIONS_COLLECTION_FETCH_FAILED, ALL_COLLECTIONS_COLLECTION_FETCH_REQUESTED } from './ActionTypes';
import { fetchCollectionItems } from '../clients/qualityClient';
import { ALL_COLLECTIONS_LENGTH } from '../constants';
import { getTotalDisplayedCollectionListings } from '../selectors/collections';

const getTotalSearchLength = totalCollections => totalCollections * ALL_COLLECTIONS_LENGTH;

export const fetchCollectionResult = collectionId => (dispatch, getState) => {
  const state = getState();
  const language = getLang();
  const totalCollections = getTotalDisplayedCollectionListings(state);
  dispatch({
    type: ALL_COLLECTIONS_COLLECTION_FETCH_REQUESTED,
    meta: {
      collectionId
    }
  });
  const request = fetchCollectionItems(collectionId, {
    length: getTotalSearchLength(totalCollections),
    language
  });
  return request.then(result => {
    dispatch({
      type: ALL_COLLECTIONS_COLLECTION_FETCH_RECEIVED,
      payload: result,
      meta: {
        collectionId
      }
    });
    return result;
  }).catch(error => {
    dispatch({
      type: ALL_COLLECTIONS_COLLECTION_FETCH_FAILED,
      payload: error,
      meta: {
        collectionId
      }
    });
    throw error;
  });
};